/**
 * Registry of all delivery (Statsig) keys used in the platform.
 * Add or remove keys here — this file is the single source of truth and the
 * intended diff surface for key changes during code review.
 */

export const DynamicConfigs = {
  platformAlert: "platform_alert",
  maintenanceWindows: "maintenance_config",
  /** The beta sign-in wall. `enabled` switches it on; `startsAt` (ISO timestamp with offset) is when
   *  it starts applying, so it can be armed ahead of time. Default (absent/null): no wall. */
  betaWall: "beta_wall",
  /** Foreground heartbeat for the claim-checking warm ping.
   *  `enabled` activates the interval; `intervalMs` sets the cadence.
   *  Default (absent/null): disabled. Flip live to activate without a redeploy. */
  claimCheckingHeartbeat: "claim_checking_heartbeat",
} as const;

export const FeatureFlags = {
  /** Route claim-checking requests to the Deno Deploy runtime instead of Supabase Edge.
   *  Off → Supabase (safe default). Evaluated per request, so flips take effect without a redeploy. */
  claimCheckingUseDenoDeploy: "claim_checking_use_deno_deploy",
  /** Shows the evidence balance bar under the verdict scale on the findings card. Off → hidden. */
  verdictBalance: "verdict_balance",
} as const;
